export default "__VITE_ASSET__B75FsdrP__"